import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BotsService {

  constructor(private http: HttpClient) { }

  getIsOrgRegistered(): Observable<any> {
    return this.http.get<any>(`${environment.vendorUrl}VendorTwilioRegistration/IsOrgRegistered`);
  }
  createSubAccount(id){
    return this.http.post<any>(`${environment.twilioAPI}api/Account/SubAccount?organizationId=${id}`, id)
    .toPromise()
    .then((res) => res);
  }
  registerTwilio(data){
    return this.http.post<any>(`${environment.vendorUrl}VendorTwilioRegistration/TwilioRegistration`, data)
    .toPromise()
    .then((res) => res);
  }
  getActiveNumbers(id){
    return this.http.get<any>(`${environment.twilioAPI}AccountActivePhoneNumber/` + id);
  }
  getMessageLogs(id, number){
    return this.http.get<any>(`${environment.twilioAPI}MessageLogs/` + id + `?phoneNumber=${number}`);
  }

  // ----------------------search number api call----------------------
  getAllCountries(id:number){
    return this.http.post<any>(`${environment.twilioAPI}CountryList/${id}`,{});
  }
  searchNumber(data:{
    SearcByNumberOrPhrase:string,
    SearchCriteria:string,
    MatchTo:number;
    CountryISOCode:string,
    OrganizationId:number,
}){
    return this.http.post<any>(`${environment.twilioAPI}AvailableNumbers/?SearcByNumberOrPhrase=${data?.SearcByNumberOrPhrase}&SearchCriteria=${data?.SearchCriteria}&MatchTo=${data?.MatchTo}&CountryISOCode=${data?.CountryISOCode}&OrganizationId=${data?.OrganizationId}`,{});
  }

  
  buyPhoneNumber(data:{
    PhoneNumber:string;
    CountryISOCode:string;
    OrganizationId:number;
  }){
    return this.http.post<any>(`${environment.twilioAPI}ProvisionPhoneNumber?PhoneNumber=${data?.PhoneNumber}&CountryISOCode=${data?.CountryISOCode}&OrganizationId=${data?.OrganizationId}`,{});
  }

  realeasePhoneNumber(data:{
    organizationId:number;
    phoneNumber:string
  }){
    return this.http.delete<any>(`${environment.twilioAPI}ReleasePhoneNumber/${data?.organizationId}/?phoneNumber=${data?.phoneNumber}`);

  }

  deactivateSubAccount(organizationId:number){
    return this.http.post<any>(`${environment.twilioAPI}api/Account/DeactivateSubAccount?OrganizationId=${organizationId}`,{});
  }

  activateSubAccount(organizationId:number){
    return this.http.post<any>(`${environment.twilioAPI}api/Account/ActivateSubAccount?organizationId=${organizationId}`,{});
  }
}
